
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topic/[topicPage]",
      function () {
        return require("private-next-pages/topic/[topicPage]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topic/[topicPage]"])
      });
    }
  